if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    return Promise.all(regs.map(r => r.unregister()))
  }).then(() => {
    if (window.caches) {
      return caches.keys().then(keys => Promise.all(keys.map(k => caches.delete(k))))
    }
  })
}
